import React from 'react';

//MUI
import { Box, BoxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface DotProps extends BoxProps {
  color?: string | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  size?: number;
}

const Dot: React.FC<DotProps> = ({ color = 'primary', size = 8, ...rest }) => {
  const theme = useTheme();

  let main;
  switch (color) {
    case 'secondary':
      main = theme.palette.secondary.main;
      break;
    case 'error':
      main = theme.palette.error.main;
      break;
    case 'warning':
      main = theme.palette.warning.main;
      break;
    case 'info':
      main = theme.palette.info.main;
      break;
    case 'success':
      main = theme.palette.success.main;
      break;
    case 'primary':
    default:
      main = color;
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: main,
      }}
      {...rest}
    />
  );
};

export default Dot;
